import { getSettings } from './getSettings';

const settings = getSettings(['century', 'settings']);

const regionDefaults = {
  learnMoreAboutLinkText: settings.learnMoreAboutLinkText,
  learnMoreAboutLinkUrl: settings.learnMoreAboutLinkUrl,
  initLat: settings.initLat,
  initLng: settings.initLng,
  initState: settings.initState,
  initZoom: settings.initZoom,
  initMobileZoom: settings.initMobileZoom,
  guestCommunityIds: settings.guestCommunityIds,
  stateName: settings.stateName,
  metroName: settings.metroName,
  cityName: settings.cityName,
  regionType: settings.regionType,
  regionId: settings.regionId,
  stateMetros: settings.metros,
  cities: settings.cities,
};

const getRegionState = stateCode => settings.searchRegionStates.find(x => x.StateCode === stateCode);

export { getRegionState, regionDefaults };